
import CountUp from 'react-countup';

const subTitle = "COMMENCEZ VERS LE SUCCÈS";
const title = "Atteignez vos objectifs avec Cotracall";


const achievementList = [
    {
        count: '30',
        desc: 'Années d\'expérience',
    },
    {
        count: '3000',
        desc: 'Stagiaires inscrits',
    },
    {
        count: '20',
        desc: 'Enseignants qualifiés',
    },
    {
        count: '100',
        desc: 'Emploi crée',
    },
]

const achieveList = [
    {
        imgUrl: 'assets/images/achive/01.png',
        imgAlt: 'achive thumb rajibraj91 rajibraj',
        title: 'Commencez à enseigner aujourd\'hui',
        // desc: 'Engagez de manière transparente un contenu coopératif techniquement solide et axé sur les objectifs plutôt que sur l\'éthique',
        desc: 'Vous êtes formateur professionnel? Déposez votre demande d\'entretien pour intégrer l\'équipe COTRACALL',
        btnText: 'Devenir instructeur',
        siteLink: '#',
    },
    {
        imgUrl: 'assets/images/achive/02.png',
        imgAlt: 'achive thumb rajibraj91 rajibraj',
        title: 'Devenir stagiaire COTRACALL',
        // desc: 'Engagez de manière transparente un contenu coopératif techniquement solide et axé sur les objectifs plutôt que sur l\'éthique',
        desc: 'Suivez une formation COTRACALL pour acquirir des compétences et booster votre carrière',
        btnText: 'Inscription gratuite',
        siteLink: '#',
    },
]


const Achievement = () => {
    return (
        <div className="achievement-section padding-tb">
            <div className="container">
                <div className="section-header text-center">
                    <span className="subtitle">{subTitle}</span>
                    <h2 className="title">{title}</h2>
                </div>
                <div className="section-wrapper">
                    <div className="counter-part mb-4">
                        <div className="row g-4 row-cols-lg-4 row-cols-sm-2 row-cols-1 justify-content-center">
                            {achievementList.map((val, i) => (
                                <div className="col" key={i}>
                                    <div className="count-item">
                                        <div className="count-inner">
                                            <div className="count-content">
                                                <h2><span>+</span><span className="count"><CountUp end={val.count} /></span></h2>
                                                <p >{val.desc}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                    <div className="achieve-part">
                        <div className="row g-4 row-cols-1 row-cols-lg-2">
                            {achieveList.map((val, i) => (
                                <div className="col" key={i}>
                                    <div className="achieve-item">
                                        <div className="achieve-inner">
                                            <div className="achieve-thumb">
                                                <img src={`${val.imgUrl}`} alt={`${val.imgAlt}`} />
                                            </div>
                                            <div className="achieve-content">
                                                <h4>{val.title}</h4>
                                                <p style={{fontFamily:  'AvenirNextReg'}}>{val.desc}</p>
                                                <a href={val.siteLink} className="lab-btn"><span>{val.btnText}</span></a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
 
export default Achievement;